import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const NumberOneComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__numberOne"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_2440_17251)">
        <path
          d="M8.00001 14.7273C11.6819 14.7273 14.6667 11.7425 14.6667 8.06062C14.6667 4.37872 11.6819 1.39395 8.00001 1.39395C4.31811 1.39395 1.33334 4.37872 1.33334 8.06062C1.33334 11.7425 4.31811 14.7273 8.00001 14.7273Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.61538 11.0606L7.61538 6.16061L7.77231 6.28561C7.68 6.45783 7.54769 6.61894 7.37538 6.76894C7.20308 6.91339 7 7.03839 6.76615 7.14394C6.53846 7.24394 6.28308 7.31894 6 7.36894V6.11894C6.22769 6.09116 6.46462 6.0245 6.71077 5.91894C6.95692 5.80783 7.17846 5.67727 7.37538 5.52727C7.57846 5.37172 7.72308 5.21616 7.80923 5.06061H9V11.0606H7.61538Z"
          fill={colorVar}
        />
      </g>
      <defs>
        <clipPath id="clip0_2440_17251">
          <rect width="16" height="16" fill="white" transform="translate(0 0.0606079)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NumberOne = withIcon(NumberOneComponent);
